<template>
  <mdb-container class="mt-2">

    <mdb-row>
      <mdb-col col="md-12">

        <jumbotron :subtitle="!canProceed ? '' : $t('slotAvailability.moreDateSubtitle')"
                   :title="$t('slotAvailability.moreDateTitle')"></jumbotron>

      </mdb-col>
    </mdb-row>

    <mdb-row>

      <mdb-col v-for="(date, index) in dates" :key="index" class="mb-3 selection-buttons" col="lg-3">
        <div :class="{'active' :  date.date_from === duration.date_from}" class="selection-button"
             @click.prevent="updateDurationWithAvailableResource({ date_from : date.date_from, date_to : date.date_to, time_from:  date.time_from, time_to:  date.time_to }, date.resource_id)">
            <span class="selection-button--text pl-2">
              {{ moment(date.date_from).format('DD.MM') }} - {{ moment(date.date_to).format('DD.MM.YYYY') }} <br/>
              {{ configurator.duration.time_from }} - {{ configurator.duration.time_to }} {{ $t('general.clock') }}
            </span>
        </div>
      </mdb-col>

      <mdb-col col="md-12">

        <mdb-alert v-if="recursionCallStack.trace.length === recursionCallStack.limit" class="alert alert-info">
          <p>{{ $t('slotAvailability.maxDepthReached') }}</p>
        </mdb-alert>

      </mdb-col>

      <mdb-col col="md-12">

        <mdb-btn block v-show="canProceed" class="large-button btn-secondary mt-3" @click="refreshAvailability">
          {{ $t('slotAvailability.moreDates') }}
        </mdb-btn>

        <mdb-btn v-show="canProceed" block class="large-button btn-primary mt-3"
                 @click="$router.push({name: 'SlotAvailability'})">
          {{ $t('general.next') }}
        </mdb-btn>

        <div class="justify-content-end" :class="{'d-none' : !canProceed, 'd-flex': canProceed}">
          <router-link :to="{name: 'ScheduleDuration'}">
            <small class="text-muted">{{ $t('slotAvailability.changeDate') }}</small>
          </router-link>
        </div>

      </mdb-col>

      <mdb-col col="md-12 mt-3 contact-info">
        <p class="title">{{ $t('slotAvailability.unavailableInfo') }}</p>
        <p class="text" v-html="$t('slotAvailability.unavailableInfoText', {phoneNumber: '+49 821 455 126 0'})"></p>
      </mdb-col>

    </mdb-row>

  </mdb-container>
</template>

<script>

import {mapGetters, mapActions} from "vuex";

export default {

  name: "MoreAvailableDates",

  metaInfo() {

    return {
      title: this.$t('slotAvailability.moreDateTitle')
    }

  },

  data() {
    return {
      startDate: null,
      endDate: null,
      interval: 0,
      dates: [],
      canProceed: false,
      recursionCallStack: {
        limit: 10,
        trace: []
      },
      persistAvailableDate: [],
    }
  },


  computed: {

    ...mapGetters({
      duration: "getDuration",
      configurator: "getConfigurator"
    }),

    moment() {
      return moment;
    }

  },

  mounted() {

    this.startDate = this.moment(this.duration.date_from);
    this.endDate = this.moment(this.duration.date_to);
    this.interval = this.moment.duration(this.endDate.diff(this.startDate)).asDays();

    this.getAvailableResource();
  },

  methods: {

    ...mapActions(["updateDuration", "updateResource", "updateIsLoading"]),

    async getAvailableResource() {

      this.updateIsLoading(true);
      if (this.dates.length >= 2) {
        this.updateIsLoading(false)
        return;
      }

      if (this.recursionCallStack.trace.length >= this.recursionCallStack.limit) {// only do a limited depth
        this.updateIsLoading(false)
        this.dates = [...this.persistAvailableDate]; // restore any available dates
        return;
      }
      this.startDate = this.moment(this.endDate).add(1, 'day');
      this.endDate = this.moment(this.startDate).add(this.interval, "day");

      const response = await this.checkResourceAvailability();

      if (response) {
        this.dates.push(response)
      }

      this.recursionCallStack.trace.push({
        date_from: this.startDate.format("YYYY-MM-DD"),
        date_to: this.endDate.format("YYYY-MM-DD")
      })

      await this.getAvailableResource();
    },

    async checkResourceAvailability() {
      let params = {
        date_from: this.startDate.format('YYYY-MM-DD'),
        date_to: this.endDate.format('YYYY-MM-DD'),
        time_from: this.duration.time_from,
        time_to: this.duration.time_to,
        // duration: '00:30',
        free_text_field_ids_str: `${this.configurator.eventType.freeTextFieldId},${this.configurator.seatType.freeTextFieldId},${this.configurator.persons.id}`,
        free_text_field_conditions_str: 'et,et,great_than_et',
        free_text_field_values_str: `${encodeURIComponent(this.configurator.eventType.title)},${encodeURIComponent(this.configurator.seatType.title)},${this.configurator.persons.count}`
      }

      if (RESOURCES) {
        params = {...params, resource_id: RESOURCES}
      }

      const response = await this.$http.getResourceAvailability(params);

      if (response.status === 200) {
        const responseData = response.data;
        if (responseData.success === true && responseData.data && responseData.data.resource_id) {
          return {
            date_from: this.startDate.format("YYYY-MM-DD"),
            date_to: this.endDate.format("YYYY-MM-DD"),
            time_from: this.duration.time_from,
            time_to: this.duration.time_to,
            resource_id: responseData.data.resource_id
          };
        }
      }
      return null;
    },

    async getMoreAvailableDates() {

      let startDate = this.moment(this.duration.date_from);
      let endDate = this.moment(this.duration.date_to);
      let duration = this.moment.duration(endDate.diff(startDate));


    },

    updateDurationWithAvailableResource(date, resource_id) {
      this.canProceed = true;
      this.updateDuration(date);

      this.$http.getResource(resource_id)
          .then(({data}) => {
            if (data.success) {
              this.updateResource(data.data);
            }
          });
    },

    refreshAvailability() {
      if (this.dates.length) {
        this.persistAvailableDate = [...this.dates]
      }
      this.dates = [];
      this.recursionCallStack.trace = [];
      this.getAvailableResource();
    }
  }
}
</script>

<style lang="scss" scoped>

.contact-info {

  .title,
  .text {
    font-weight: 300;
    font-size: 19px;
  }

  .title {
    font-weight: 500;
    margin-top: 5%;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/pages/slot-availability/more-dates.vue